export const LOG_LEVEL = {
  INFO: "info",
  WARNING: "warn",
  SUCCESS: "success",
  ERROR: "error"
};